<template>
    <div>
        <v-row>

            <!-- Actions -->
            <ActionDropdown 
                :items="actions"
                context="LabelContracts"
                :alvqa="alvqa"
            />

            <!-- Header stats -->
            <v-col 
                v-if="totalRecords !== null"
                align-self="center"
                col="4"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="LabelContracts" 
                    typeStats="LIST" 
                    :alvqa="alvqa + '-list'" 
                />
            </v-col>

            <v-spacer></v-spacer>

            <!-- New Contract button -->
            <v-col                
                cols="3"
                align-self="center"
            >
                <BaseButton 
                    label="lang_GENERIC_CONTRACTS_CAPTION_NEW_CONTRACT"
                    :to="{name: editForm, params: { alvId: 'new' }}"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'

export default {
    name: "LabelContractsTopSlot",
    components: {
        BaseButton,
        ActionDropdown,
        BaseHeaderStats,
    },
    data() {
        return {
            editForm: "LabelContractsEdit",
            alvqa: "contracts-label"
        }
    },
    computed: {
        totalRecords() { return this.$store.getters.getTotalRecords },
        actions() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_EXPORT'), 
                    value: 'export',
                    alvqa: this.alvqa + '-list-action-dropdown-export'
                },
                { 
                    text: this.$t('lang_LABEL_RELEASES_ACTION_OPTION_COPY_WITH_TRACKS'), 
                    value: 'copyWithTracks', 
                    alvqa: this.alvqa + '-list-action-dropdown-copy-with-tracks'
                },
                { 
                    text: this.$t('lang_LABEL_RELEASES_ACTION_OPTION_COPY_WITHOUT_TRACKS'), 
                    value: 'copyWithoutTracks', 
                    alvqa: this.alvqa + '-list-action-dropdown-copy-without-tracks'
                },
                { 
                    text: this.$t('lang_PUBLISHING_CONTRACTS_ACTION_GROUP'), 
                    value: 'groupContracts', 
                    alvqa: this.alvqa + '-list-action-dropdown-group-contracts'
                },
                { 
                    text: this.$t('lang_PUBLISHING_CONTRACTS_ACTION_UNGROUP'), 
                    value: 'ungroupContracts', 
                    alvqa: this.alvqa + '-list-action-dropdown-ungroup-contracts'
                },
                { 
                    text: this.$t('lang_PUBLISHING_INCOME_ACTION_OPTION_MOVE'),
                    value: 'move', 
                    alvqa: this.alvqa + '-list-action-dropdown-move'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_MANAGE_TAGS'),
                    value: 'replaceTags',
                    alvqa: this.alvqa + '-list-action-dropdown-manage-tags'
                },
                { 
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete', 
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                },
            ]
        }
    }
}
</script>